module.exports = __webpack_public_path__ + "static/media/pm_hc_products6.5e554044.png";